import { AlertColor } from '@mui/material';
import { store } from 'v3/data/store';
import { snackbarSlice } from 'v3/data/store/snackbar/index';

export const showSnackbar = (title: string, severity: AlertColor, error: boolean) => {
  store.dispatch(snackbarSlice.actions.showSnackbar({ title, severity, error }));
};

export const hideSnackbar = () => {
  store.dispatch(snackbarSlice.actions.hideSnackbar());
};
